module.exports = __webpack_public_path__ + "img/leadership-1978-document.f9bfa589.jpg";